import { Stack } from '../../../../../../components/core';
import { mergeClasses } from '@fluentui/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset } from '@fortawesome/free-solid-svg-icons';
import ViaeroButton from '../../../../../../components/core/ViaeroButton/ViaeroButton';
import useCreditCheckFollowupBoxStyles from '../CreditCheckFollowupBox.styles';

export interface ICreditCheckCartRedirect {
    onClick: () => void;
}
const CreditCheckCartRedirect = (props: ICreditCheckCartRedirect) => {
    const { onClick } = props;

    const styles = useCreditCheckFollowupBoxStyles();

    return (
        <Stack
            horizontal
            className={mergeClasses(styles.followupContainer, styles.completedStatus)}
        >
            <FontAwesomeIcon icon={faHeadset} className={styles.completedIcon} />
            <div>
                <h2 className={styles.header}>
                    We will get in touch with you soon to continue your order, or chat with us or
                    call our team at 1.877.484.2376.
                </h2>
                <p className={styles.fadedBodyText}>
                    For requests outside normal business hours, we will contact you on the next
                    business day.
                </p>
                <ViaeroButton
                    text={'View Cart'}
                    click={onClick}
                    className={styles.viewCartButton}
                />
            </div>
        </Stack>
    );
};

export default CreditCheckCartRedirect;
